import { render, staticRenderFns } from "./HorizontalList.vue?vue&type=template&id=b6c9c09c&"
import script from "./HorizontalList.vue?vue&type=script&lang=js&"
export * from "./HorizontalList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports